@if (sectionId === 0) {
  <div>
    <div class="intro">
      <h1>Course Dashboard</h1>
    </div>
    @if (isOffline) {
      <div class="card">
        <div class="card-body">
          <div class="pl-2">
            <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
          </div>
        </div>
      </div>
    }
    @if (isDemoUser || isDemo2User) {
      <div class="card" >
        <div class="card-body featured">
          <div class="row">
            <div class="section-widget course-section-widget col-12 mb-0">
              <h3 class="card-title h4">Welcome!</h3>
              <p class=lead>This demonstration course gives you a flavour of online learning at Edinburgh Business
                School. Try our custom-built platform, access the high-quality materials developed by our team,
              and get a sense of how flexible our approach is.</p>
              <p>This is an abridged version of one of our most popular courses. It
                includes the first two modules and the induction materials (module 0). The full course
              includes further self-contained modules with videos, activities, practice exams and ebook access.</p>
              <p>The course dashboard (right here) gives you a snapshot of where you are in the course. It
                summarises
                your test scores and participation, and includes links to materials that you can download for
                offline study.
              </p>
              <p class="lead">To get started go to <a [routerLink]="linkToFirstSectionOfCourse">Module 0: About this Course</a>.
              We'd love to hear from you if you have any questions, so please <a href="https://ebs.online.hw.ac.uk/contact-us"
            target="new">get in touch</a>. Or if you’re ready to sign up, <a href="https://ebs.online.hw.ac.uk/apply"
          target="new">apply now</a>.</p>
          <p><a href="https://ebs.online.hw.ac.uk/contact-us" target="new"
          class="btn btn-md d-block d-md-inline-block  btn-primary mt-3">Get in touch</a>
          <span class="pr-2">&nbsp;</span>
          <a href="https://ebs.online.hw.ac.uk/apply" target="new"
          class="btn btn-md d-block d-md-inline-block  btn-primary mt-3">Apply now</a></p>
        </div>
      </div>
    </div>
  </div>
}
<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="section-widget course-section-widget col-12 mb-0">
        <h3 class="card-title h4">Your Progress</h3>
        @if (gettingProgress) {
          <ebs-spinner [spinnerMessage]="'loading progress'"></ebs-spinner>
        }
        @if (showProgressError) {
          <ebs-notification-multiple [notifications]="progressNotifications">
          </ebs-notification-multiple>
        }
        @if (!showProgressError) {
          <span class="p-1">
            {{percentComplete}}% complete.
            <div class="mt-2">
              <ebs-progress-bar [progressWrapperWidth]="100" [showValueInBar]="false" [progressMax]="100"
              [progressValue]="percentComplete"></ebs-progress-bar>
            </div>
          </span>
        }
      </div>
      <div class="section-widget course-section-widget col-12 border-bottom pb-4 pt-0">
        <h3 class="h5">Last Section Visited</h3>
        @if (gettingLastAccessed) {
          <ebs-spinner [spinnerMessage]="'loading last section data'">
          </ebs-spinner>
        }
        @if (lastAccessed && lastAccessed.sectionUri) {
          <div class="p-1">
            <span class="font-italic font-weight-bold">"{{lastAccessed.sectionName}}"</span>
            @if (!isMobile) {
              <span> when online on
              {{lastAccessed.dateTimeOfLastSectionAccess | date:'EEE, d MMM y, H:mm'}} </span>
            }
            @if (isMobile) {
              <span> when online on
                {{lastAccessed.dateTimeOfLastSectionAccess | date:'MMM d, y'}}
              </span>
            }
          </div>
        }
        @if (lastAccessed && lastAccessed.sectionUri === null) {
          <div>You have not accessed any of your
          learning modules. </div>
        }
        @if (lastAccessed && lastAccessed.sectionUri) {
          <a [routerLink]="['/' + lastAccessed.sectionUri]"
          class="btn btn-md d-block d-md-inline-block  btn-primary mt-3">Return to Section</a>
        }
        @if (showLastAccessError && !isOffline) {
          <ebs-message-simple [displayMessage]="displayMessage">
          </ebs-message-simple>
        }
      </div>
      <!--STATS COMMENTED OUT FOR RELEASE-->
      @if (displayQuizStats) {
        <div
          class="col-sm-12 col-12 col-md-6 col-lg-6 section-widget course-section-widget">
          @if (quizStatsIsLoading) {
            <ebs-spinner [spinnerMessage]="'loading progress'"></ebs-spinner>
          }
          @if (showProgressError) {
            <ebs-notification-multiple [notifications]="progressNotifications">
            </ebs-notification-multiple>
          }
          @if (!quizStatsIsLoading) {
            <div>
              <ebs-quiz-statistics-average [quizStatistics]="quizStatistics"></ebs-quiz-statistics-average>
              <div id="collapseQuizStats">
                @if (showQuizStatsDetails) {
                  <ebs-quiz-statistics-details [quizStatistics]="quizStatistics">
                  </ebs-quiz-statistics-details>
                }
              </div>
              <button (click)="quizStatsToggle()"
                class="btn btn-block btn-outline-secondary btn-sm collapsed mt-2 d-lg-none" type="button"
                data-toggle="collapse" data-target="#collapseQuizStats" aria-expanded="false"
              aria-controls="collapseQuizStats">View {{buttonTextQuiz}}</button>
            </div>
          }
        </div>
      }
      @if (displayStatistics) {
        <div
          class="col-sm-12 col-12 col-md-6 col-lg-6 section-widget course-section-widget ">
          @if (quizStatsIsLoading) {
            <ebs-spinner [spinnerMessage]="'loading progress'"></ebs-spinner>
          }
          @if (discussionStatsIsLoading) {
            <ebs-notification-multiple [notifications]="progressNotifications">
            </ebs-notification-multiple>
          }
          @if (!discussionStatsIsLoading) {
            <div>
              <discussion-engagement
                [moduleDiscussionEngagementStatistics]="moduleDiscussionEngagementStatistics">
              </discussion-engagement>
              <div id="collapseDiscussionStats">
                @if (showDiscussionStatsDetails) {
                  <discussion-engagement-statistics-details
                    [moduleDiscussionEngagementStatistics]="moduleDiscussionEngagementStatistics">
                  </discussion-engagement-statistics-details>
                }
              </div>
              <button (click)="discussionStatsToggle()"
                class="btn btn-block btn-outline-secondary btn-sm collapsed mt-2 d-lg-none" type="button"
                data-toggle="collapse" data-target="#collapseDiscussionStats" aria-expanded="false"
              aria-controls="collapseDiscussionStats">View {{buttonText}}</button>
            </div>
          }
        </div>
      }
      @if (displayStatistics || displayQuizStats) {
        <button (click)="toggleBoth()"
          class="btn btn-block btn-outline-secondary btn-sm collapsed my-2 mx-4 d-none d-lg-block"
          type="button" data-toggle="collapse" data-target="#collapseQuizStats, #collapseDiscussionStats"
          aria-expanded="false" aria-controls="collapseQuizStats, collapseDiscussionStats">View
        {{buttonText}}</button>
      }
      @if (!displayQuizStats && !displayStatistics) {
        <ebs-message-simple [iconCssClasses]="'fas fa-exclamation-circle fa-lg'" [textCssClasses]="''"
          [displayMessage]="notAvailableMessage">
        </ebs-message-simple>
      }
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-12 col-md-6 col-lg-6 section-widget course-section-widget">
          <h4>Current Offline Content</h4>
          @if (supportsServiceWorkers) {
            <span>
              @if (!localCourseSet) {
                <ebs-spinner [spinnerMessage]="'getting current download list'">
                </ebs-spinner>
              }
              @if (localCourseSet) {
                <ebs-downloads-current [courseCode]="courseId">
                </ebs-downloads-current>
              }
              <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='downloadedOfflineMessage'>
              </ebs-offline-message>
              @if (!isOffline && localCourseSet) {
                <a [routerLink]="downloadsLink" class="btn btn-primary wrapButtonText"
                  >
                  Manage offline content
                </a>
              }
            </span>
          }
          @if (!supportsServiceWorkers) {
            <div class="card" [@enterOrLeave]="!supportsServiceWorkers"
              style="border-radius: 6px">
              <div class="card-header p-0" style="border: none !important">
                <ebs-message-simple
                  [displayMessage]="'Offline mode is not supported by your browser. Please upgrade to a modern browser.' "
                  [textCssClasses]="'text-info'"
                  [iconCssClasses]="'text-info fa fa-fw fa-exclamation-circle'">
                </ebs-message-simple>
              </div>
            </div>
          }
        </div>
        <div class="col-sm-12 col-12 col-md-6 col-lg-6 section-widget course-section-widget">
          <h4>Printable materials</h4>
          <p>You can print individual modules as PDFs for reviewing offline. </p>
          <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='printablesOfflineMessage'>
          </ebs-offline-message>
          @if (!isOffline) {
            <a [routerLink]="printableMaterialsLink" class="btn btn-primary wrapButtonText"
              >
              Go to printable materials
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-12 col-md-6 col-lg-6 section-widget course-section-widget">
          <h4>Email Notifications</h4>
          <p>You can manage which email notifications you receive for discussions and forum topics on this
          course. </p>
          <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='printablesOfflineMessage'>
          </ebs-offline-message>
          @if (!isOffline) {
            <a [routerLink]="manageSubsLink" class="btn btn-primary wrapButtonText">
              Manage subscriptions
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>
}

<!--content-->
@if (sectionId > 0) {
  <div>
    @if (!gettingSection) {
      <div style="margin-bottom: 40px;">
        <!-- <div class="d-none d-print-block">There has been an error when loading some or all of this page</div> -->
        @if (errorOccured) {
          <ebs-message-simple [displayMessage]="errorMessage"></ebs-message-simple>
        }
        @if (showOfflineMessage) {
          <div>
            <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineSectionMessage'></ebs-offline-message>
          </div>
        }
        @if (!errorOccured && !showOfflineMessage) {
          <div>
            <ebs-section [section]='section'></ebs-section>
            <ebs-section-progress (bubbleMenuUpdateFromProgress)="handleMenuUpdated($event)" [sectionId]="sectionId"
            [showProgress]="sectionIsComplete"></ebs-section-progress>
            <div class="card hidden-print">
              <div class="card-body">
                <div class="row next-previous-row">
                  <div class="col-6">
                    @if (!hidePrev) {
                      <button class="btn btn-outline-secondary float-left btn-block" (click)="routePrevious()"
                        >
                        <i class="fa fa-fw fa-chevron-circle-left"></i> &nbsp; {{prevText}} </button>
                      }
                    </div>
                    <div class="col-6">
                      @if (!hideNext) {
                        <button class="btn btn-primary float-right btn-block" (click)="routeNext()"
                          >
                          {{nextText}} &nbsp;<i class="fa fa-fw fa-chevron-circle-right"></i> </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (sectionId === -1) {
      <ebs-e-books></ebs-e-books>
    }
    @if (sectionId === -2) {
      <ebs-printable-materials [courseCode]="courseId"></ebs-printable-materials>
    }
    @if (sectionId === -3) {
      <ebs-downloads [courseCode]="courseId" [currentUser]="currentUser"></ebs-downloads>
    }
    <!--Forums-->
    @if (sectionId === -4) {
      <ebs-forum-list [courseCode]="courseId"></ebs-forum-list>
    }
    @if (sectionId === -5) {
      <ebs-forum-add [courseCode]="courseId"></ebs-forum-add>
    }
    <!--ADD-->
    @if (sectionId === -6) {
      <ebs-forum [courseCode]="courseId"></ebs-forum>
    }
    @if (sectionId === -7) {
      <ebs-forum-add [formMode]="'edit'" [courseCode]="courseId"></ebs-forum-add>
    }
    <!--EDIT-->
    <!--End Forums-->
    @if (sectionId === -8) {
      <ebs-email-subscription [courseCode]="courseId"></ebs-email-subscription>
    }